import { BarChart, XAxis, YAxis, Tooltip, Bar, ReferenceLine, ResponsiveContainer } from "recharts";

import { SortOrder } from "../../service/utils/constants";
import { WasteTotalVerticalEntry } from "../../service/utils/interfaces";

interface LeaderboardGraphProps {
  arrayData: WasteTotalVerticalEntry[],
  darkMode: boolean,
  filterVal: number,
  sortOrder: SortOrder,
  width: number
};

const LeaderboardGraph = (props: LeaderboardGraphProps) => {
  const leftMargin = props.width >= 1920 ? 140 :
    props.width >= 1440 ? 80 :
      props.width >= 1280 ? 75 :
        props.width >= 1023 ? 60 : 60;
  const height = props.width >= 1920 ? 170 :
    props.width >= 1440 ? 185 :
      props.width >= 1280 ? 188 :
        props.width >= 1023 ? 194 : 194;
  // Show all items from the selected array (top or bottom)
  const displayedArray = props.arrayData;

  const fontMultiplier = props.width >= 1920 ? 13.173 :
    props.width >= 1440 ? 9 :
      props.width >= 1280 ? 8.493 :
        props.width >= 1023 ? 6.627 : 8.04;
  const longestNameLength = props.arrayData.reduce((maxLength, el) =>
    Math.max(maxLength, el.name.length)
  , 0);
  const yAxisWidth = Math.min((longestNameLength * fontMultiplier), 200);

  const minValue = displayedArray.reduce((min, el) => {
    const value = props.filterVal === 1 ? el.value1 :
      props.filterVal === 2 ? el.value2 :
        el.value3;
    return Math.min(min, value);
  }, 0);
  const maxValue = displayedArray.reduce((max, el) => {
    const value = props.filterVal === 1 ? el.value1 :
      props.filterVal === 2 ? el.value2 :
        el.value3;
    return Math.max(max, value);
  }, 0);

  return (
    <ResponsiveContainer width="100%" height={height}>
    <BarChart
      layout='vertical'
      data={displayedArray}
      margin={{left: Math.max(0, leftMargin - (200 - yAxisWidth)), right: 10}}
      style={{cursor: 'pointer'}}
    >
      <XAxis
        type='number'
        tick={{fill: props.darkMode ? '#fff' : '#666', fontSize: 'var(--paragraph-font)'}}
        domain={[minValue, maxValue]}
      />
      <YAxis
        dataKey="name"
        type='category'
        tick={{
          width: yAxisWidth,
          fill: props.darkMode ? '#fff' : '#666',
          fontSize: 'var(--paragraph-font)'
        }}
      />
      <Tooltip
        cursor={false}
        wrapperClassName={'tooltip-wrapper' + (props.darkMode ? ' dark' : '')}
      />
      <ReferenceLine x={0} stroke={props.darkMode ? '#fff' : '#666'} />
      {props.filterVal === 1 && (
        <Bar
          name='% Recycling Rate'
          barSize={15}
          dataKey="value1"
          fill={props.darkMode ? '#00cccc' : '#00b2b2'}
        />
      )}
      {props.filterVal === 2 && (
        <Bar
          name='% Emissions Rate'
          barSize={15}
          dataKey="value2"
          fill={props.darkMode ? '#7c97de' : '#122048'}
        />
      )}
      {props.filterVal === 3 && (
        <Bar
          name='% Waste Reduced'
          barSize={15}
          dataKey="value3"
          fill="#ff3600"
        />
      )}
    </BarChart>
    </ResponsiveContainer>
  );
};

export default LeaderboardGraph;
